__turbopack_context__.v({
  "bestPractices": "U2CuGa_bestPractices",
  "bestPracticesTitle": "U2CuGa_bestPracticesTitle",
  "checkbox": "U2CuGa_checkbox",
  "checkboxLabel": "U2CuGa_checkboxLabel",
  "checkboxText": "U2CuGa_checkboxText",
  "checkboxWrapper": "U2CuGa_checkboxWrapper",
  "closeButton": "U2CuGa_closeButton",
  "content": "U2CuGa_content",
  "continueButton": "U2CuGa_continueButton",
  "description": "U2CuGa_description",
  "dialog": "U2CuGa_dialog",
  "iconWrapper": "U2CuGa_iconWrapper",
  "overlay": "U2CuGa_overlay",
  "practiceContent": "U2CuGa_practiceContent",
  "practiceIcon": "U2CuGa_practiceIcon",
  "practiceItem": "U2CuGa_practiceItem",
  "practiceText": "U2CuGa_practiceText",
  "practiceTitle": "U2CuGa_practiceTitle",
  "subTitle": "U2CuGa_subTitle",
  "title": "U2CuGa_title",
});
